const firebaseConfig = {
    apiKey: "AIzaSyAMjkCjkm-t9Jpd30XPD99y40Q4jdARlcM",
    authDomain: "theonething-4c504.firebaseapp.com",
    projectId: "theonething-4c504",
    storageBucket: "theonething-4c504.appspot.com",
    messagingSenderId: "561699982614",
    appId: "1:561699982614:web:563d2b0bc9217393229437",
    measurementId: "G-HYH26L6W5J"
  };  

export default firebaseConfig;
